import { Component } from "react";
import ListingWebServices from "../service/listing_web_services";
import ProposalServices from "../service/proposal_web_services";
import QuotaionServices from "../service/quotation_service";
import DataResult from "../data/bean/data_result";
import Config from "../Config";
import LanguageBloc from "./language_bloc";
import Labels from "../ui/constant/labels";
import UtilBloc from "./util_bloc";
import ContactServices from "../service/contact_service";
import GeneralBloc from "./general_bloc";
import moment from "moment";

class ContactBloc extends Component {

  //getContactSteps
  static getContactSteps(action) {
    return [
      {
        label: action == "create" ? "LBL_CREATE_CONTACT" : "LBL_UPDATE_CONTACT",
      },
      {
        label: "LBL_CONTACT_DETAILS",
      }
    ];
  }

  //deleteContactById
  static async deleteContactById(id,payload) {
    let resp = await ContactServices.deleteContactById(id,payload);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //softDeleteClientById
  static async softDeleteClientById(id) {
    let resp = await ContactServices.softDeleteClientById(id);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  

  //getQuotationDetail by ID
  static async getQuotationDetail(documentId, id) {
    let payload = {
      "<id>": documentId,
    };
    let result = {};

    let response = await ListingWebServices.getListingDetail(payload, id);
    //console.log("check response", response);
    if (response.success) {
      result = this.mapQuotationDetail(response, module);
    }

    return result;
  }

  //get sections(PERSONAL_DETAILS,FINANCING_DETAILS,TAKAFUL_DETAILS) in QuotationDetail
  /* static mapQuotationDetail(response) {
    let generatedDocument = [];

    
    response.data.uploaded_document.data.forEach((item) => {
      let record = {};
      record = {
        caption: item.document.name,
        value: item.uploaded_document.id,
        size: item.uploaded_document.properties.sizeMB,
        type: item.uploaded_document.properties.format,
      };
      generatedDocument.push(record);
    });

    let  indexOfPersonalDetails = 0;
    response.data.attributes.data.findIndex(
      (item) => item.quotation_attr.category === "PERSONAL_DETAILS"
    );

    

    let  indexOfFinancialDetails =0;
    indexOfFinancialDetails = response.data.attributes.data.findIndex(
      (item) => item.quotation_attr.category === "FINANCING_DETAILS"
    );
    

    let indexOfTakafulDetails = 0;
    indexOfTakafulDetails = response.data.attributes.data.findIndex(
      (item) => item.quotation_attr.category === "TAKAFUL_DETAILS"
    );
    

    let personalDetailsAttr = response.data.attributes.data[indexOfPersonalDetails];

  

    let financialDetailsAttr = response.data.attributes.data[indexOfFinancialDetails];

    

    let takafulDetailsAttr = response.data.attributes.data[indexOfTakafulDetails];

    
    let data = null;
    if (response.data.attributes.data.length > 0) {
      data = {
        status: response.data.quotation.data[0].quotation.trxStatus,
        refNo: response.data.quotation.data[0].quotation.refNo,
        personalDetails: {
          caption: Labels.LBL_PERSONAL_DETAILS,
          name: {
            caption: Labels.LBL_NAME,
            value: personalDetailsAttr.quotation_attr.properties.name ?? "",
          },
          typeId: {
            caption: Labels.LBL_ID_TYPE,
            
            value:
              personalDetailsAttr.quotation_attr.properties.typeId.description,
          },
          idNo: {
            caption: Labels.LBL_ID_NUMBER,
            value: personalDetailsAttr.quotation_attr.properties.idNo,
          },
          otherIdNo: {
            caption: Labels.LBL_OTHER_NRIC_NO,
            value: personalDetailsAttr.quotation_attr.properties.otherIdNo,
          },
          dob: {
            caption: Labels.LBL_DOB,
            value: personalDetailsAttr.quotation_attr.properties.dob,
          },
          anb: {
            caption: Labels.LBL_AGE_ANB,
            value: personalDetailsAttr.quotation_attr.properties.anb,
          },
          dateOfQuotation: {
            caption: Labels.LBL_DATE_QUOTATION,
            value:
              personalDetailsAttr.quotation_attr.properties.dateOfQuotation,
          },
        },
        financialDetails: {
          caption: Labels.LBL_FINANCIAL_DETAILS,
          financingBank: {
            caption: Labels.LBL_FINANCING_BANK,
            value:
              financialDetailsAttr.quotation_attr.properties.financingBank
                .description,
          },
          financingAccNo: {
            caption: Labels.LBL_FINANCING_ACCOUNT_NO,
            value:
              financialDetailsAttr.quotation_attr.properties.financingAccNo,
          },
          bankRefNo: {
            caption: Labels.LBL_BANK_REFERENCE_NO,
            value: financialDetailsAttr.quotation_attr.properties.bankRefNo,
          },
          eligibleB40: {
            caption: Labels.LBL_ELIGIBLE_SCHEME,
            value: UtilBloc.convertToLocaleObject(
              financialDetailsAttr.quotation_attr.properties
                .eligibleB40.label,
              financialDetailsAttr.quotation_attr.properties
                .eligibleB40.label == "Yes"
                ? "Ya"
                : "Tidak"
            ),
          },
          financingAmount: {
            caption: Labels.LBL_FINANCING_AMOUNT,
            value:
              financialDetailsAttr.quotation_attr.properties.financingAmount,
            
            prefix: "RM ",
            suffix: ".00",
          },
          financingPercentage: {
            caption: Labels.LBL_FINANCING_PERCENTAGE,
            value:
              financialDetailsAttr.quotation_attr.properties
                .financingPercentage,
            type: "number",
            fixed: 2,
            suffix: "%",
          },
          coveredFinancingAmount: {
            caption: Labels.LBL_COVERED_FINANCING_AMOUNT,
            value:
              financialDetailsAttr.quotation_attr.properties
                .coveredFinancingAmount,
            
            prefix: "RM ",
            suffix: ".00",
          },
          assuredBankRate: {
            caption: Labels.LBL_ASSUMED_BANK_RATE,
            value:
              financialDetailsAttr.quotation_attr.properties.assuredBankRate,
            type: "number",
            fixed: 2,
            suffix: "%",
          },
          financingPeriod: {
            caption: Labels.LBL_FINANCING_PERIOD,
            value:
              financialDetailsAttr.quotation_attr.properties.financingPeriod,
            type: "number",
            fixed: 0,
            suffix: " Years",
          },
          derefmentPeriod: {
            caption: Labels.LBL_DEFERMENT_PERIOD,
            value:
              financialDetailsAttr.quotation_attr.properties.defermentPeriod
                .description,
            type: "number",
            fixed: 0,
            suffix: " Years",
          },
        },
        takafulDetails: {
          caption: Labels.LBL_TAKAFUL_DETAILS,
          termOfCoverage: {
            caption: Labels.LBL_TERM_COVERAGE,
            value: takafulDetailsAttr.quotation_attr.properties.termOfCoverage,
            type: "number",
            fixed: 0,
            suffix: " Years",
          },
          initialSumCovered: {
            caption: Labels.LBL_INITIAL_SUM_COVERED,
            value:
              takafulDetailsAttr.quotation_attr.properties.initialSumCovered,
            
            prefix: "RM ",
            suffix: ".00",
          },
          contributionAmount: {
            caption: Labels.LBL_CONTRIBUTION_AMOUNT,
            value:
              takafulDetailsAttr.quotation_attr.properties.contributionAmount,
            prefix: "RM ",
            suffix: ".00",
          },
          contributionMode: {
            caption: Labels.LBL_CONTRIBUTION_MODE,
            value:
              takafulDetailsAttr.quotation_attr.properties.contributionMode,
          },
          contributionType: {
            caption: Labels.LBL_CONTRIBUTION_TYPE,
            value:
              takafulDetailsAttr.quotation_attr.properties.contributionType
                .description,
          },
        },
        generatedDocuments: {
          caption: Labels.LBL_GENERATED_DOCUMENTS,
          data: generatedDocument,
        },
      };
    }

    return data;
  } */

  static async createNewContact() {
    let response = await ContactServices.newContact();

    if (response.success) {
      return response.data.client.id;
    }
  }

  //mapQuotationPersonalDetailForm
  static mapQuotationPersonalDetailForm(response) {
    let record = {};
    let formattedDateDob = "";
    let fomattedDateQuotation = "";
    //console.log("response data:", response);
    if (response.data.length > 0) {
      if (response.data[0].quotation_attr.properties.dob) {
        formattedDateDob =
          response.data[0].quotation_attr.properties.dob
            .split("/")
            .reverse()
            .join("/") ?? "";

        fomattedDateQuotation =
          response.data[0].quotation_attr.properties.dateOfQuotation
            .split("/")
            .reverse()
            .join("/") ?? "";
      }

      let idNo = response.data[0].quotation_attr.properties.idNo;

      // if (response.data[0].quotation_attr.properties.typeId == "NRIC") {
      //   const number = response.data[0].quotation_attr.properties.idNo;

      //   let digit1 = number.slice(0, 6);
      //   let digit2 = number.slice(6, 8);
      //   let digit3 = number.slice(8, 14);

      //   idNo = `${digit1}-${digit2}-${digit3}`;
      // }
      record = {
        name: response.data[0].quotation_attr.properties.name ?? "",
        typeId: response.data[0].quotation_attr.properties.typeId ?? "",
        idNo: idNo ?? "",
        otherIdNo: response.data[0].quotation_attr.properties.otherIdNo ?? "",
        dob: formattedDateDob ?? "",
        anb: String(response.data[0].quotation_attr.properties.anb ?? ""),
        dateOfQuotation: fomattedDateQuotation ?? "",
      };
    }

    //console.log("RECORED", record);
    return record;
  }

  //Save contact details in Contact Flow
  static async saveForm(payload) {
    let resp = await ContactServices.saveContact(payload);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message);
    }
  }

  //getFormDetailContact in Contact Flow
  static async getFormDetailContact(id,from) {
    let result = {};
    let response = await ContactServices.getContact(id);
    if (response.success) {
      result = this.mapQuotationPersonalDetailForm(response,from);
    }
    return result;
  }

  static  getCurrentDateInYYYYMMDD() {
    const today = new Date();
  
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
    const day = String(today.getDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`;
  }

  static convertDateToYYYYMMDD(dateStr) {
    // Split the input date string by '/'
    const [day, month, year] = dateStr.split('/');
  
    // Rearrange the components to form the desired format
    const formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  
    return formattedDate;
  }
  
  
  //get PersonalDetailForm data from backend
  static mapQuotationPersonalDetailForm(response,from) {
    let record = {};
    if (response.data) {
      //console.log("response.data",response.data)
      record = {
        /* title: response.data.title, */
        name: response.data.name,
        gender: response.data.gender,
        /* idNo: response.data.idNo,
        otherIdNo: response.data.otherIdNo, */
        dob: response.data.dob,
        anb: response.data.anb,
        occupation: response.data.occupation,
        nob: response.data.nob,
        occupationClass: response.data.occupationClass,
        /* mobileNumber: response.data.mobileNumber,
        businessContact: response.data.businessContact,
        residenceContact: response.data.residenceContact, */
        email: response.data.email,
       /*  maritalStatus: response.data.maritalStatus, */
        smoked: response.data.smoked,
        company: response.data.company,
        /* corresAddress: response.data.corresAddress,
        residentialAddress: response.data.residentialAddress,
        nationality: response.data.nationality,
        residentialAddressSameCorresAddress: response.data.residentialAddressSameCorresAddress,
        occupationExactDuty: response.data.occupationExactDuty,
        countryCodeBusinessTel: response.data.countryCodeBusinessTel,
        countryCodeMobile: response.data.countryCodeMobile,
        countryCodeResidenceTel: response.data.countryCodeResidenceTel, */
      };
    }
    if(from=="contact"){
      delete record.anb
    }else {
      if(UtilBloc.isNullOrEmpty(record.anb)){  
        let currentDate=this.getCurrentDateInYYYYMMDD()
        let dob= this.convertDateToYYYYMMDD(record.dob);       
        record.anb=GeneralBloc.anbChecking(currentDate,dob)  //fnCalculateAgeFromGivesDates(formatDob[1]+"/"+formatDob[0]+"/"+formatDob[2]);
      }          
    }    
    //console.log("RECORD",record)
    return record;
  }

  //Get list of contacts
  static async getListingData(
    dateFilter,
    status,
    fromDate,
    toDate,
    page,
    searchBy,
    keyword = "",
    searchCriteria,
    filters,
    filtersAll,
    statuses,
    userConfig,
    searchType
  ) {
    let dataResult = {};

    let date = GeneralBloc.getFilteredByDate(dateFilter, fromDate, toDate);

    let condition = [
      {
        entity: "client",
        field: "updatedOn",
        value: date.beginDate,
        type: ">",
      },
      {
        entity: "client",
        field: "updatedOn",
        value: date.endDate,
        type: "<",
      },
    ];

    if (status == "ALL") {
      condition = [
        {
          entity: "client",
          field: "updatedOn",
          value: date.endDate,
          type: "<",
        },
        {
          entity: "client",
          field: "updatedOn",
          value: date.beginDate,
          type: ">",
        },
      ];
    }

    let payload = {};
    let keywoardResult = "";
    keywoardResult = keyword.length > 0 ? keyword : "";

    if (status == "ALL") {
      payload = {
        "page": page,
        "keyword": keywoardResult,
        "condition": condition,
      };
    } else {
      payload = {
        "page": page,
        "status": status,
        "keyword": keywoardResult,
        "condition": condition,
      };
    }


    let response = await ContactServices.getListing(payload, searchCriteria);
    //console.log("Check data >>>", response);

    if (response.success) {
      //console.log("Check data >>>1");
      dataResult = GeneralBloc.getListingData(response,"contact");
    }
    //console.log("Check data >>>2");
    let limit = [];
    limit.push(dataResult.limitData);
    //console.log("Check data >>>3");
    let result = {
      data: dataResult.data || [],
      dataCollumn: dataResult.dataCollumn || [],
      totalData: dataResult.totalData || [],
      totalPage: dataResult.pageCount || 0,
      limitData: limit,
      currentPage: dataResult.curretnPage,
    };

    return result;
  }

}

export default ContactBloc;
